import { ApiFilestackImageData } from 'api/types/ApiFilestackImageData';
import { FilestackImage } from 'components/FilestackImage/FilestackImage';
import { BodySmall } from 'components/Text/BodySmall';
import { colors } from 'theme';

import {
  CmsTileModalLeftContentContainer,
  CmsTileModalLeftContentImageContainer,
} from './CmsTileModalLeftContent.styled';

type Props = {
  imageData: ApiFilestackImageData;
  caption: string | undefined;
};

export function CmsTileModalLeftContent({ imageData, caption }: Props) {
  return (
    <CmsTileModalLeftContentContainer>
      <CmsTileModalLeftContentImageContainer>
        <FilestackImage
          data={imageData}
          objectFit="cover"
          expandSize
          width={1200}
          height={1200}
        />
      </CmsTileModalLeftContentImageContainer>

      {caption && (
        <div style={{ marginTop: 8 }}>
          <BodySmall color={colors.lightContentGrey} tag="figcaption">
            {caption}
          </BodySmall>
        </div>
      )}
    </CmsTileModalLeftContentContainer>
  );
}
